import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { RestResponse } from "../classes/rest-response";
import { ApiHeaders } from "../classes/api-headers";

@Injectable()
export class MasterProvider {
  baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  getHotelGroupList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/HotelInfo/GetHotelGroups`, ApiHeaders.getOptions());
  }

  addHotelGroup(name: string, isActive: boolean, formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/HotelInfo/AddHotelGroup?Name=${name}&IsActive=${isActive}`, formData);
  }

  updateHotelGroup(id: number, name: string, isActive: boolean, formData: FormData): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/api/HotelInfo/EditHotelGroup?Id=${id}&Name=${name}&IsActive=${isActive}`, formData);
  }

  deleteHotelGroup(id: number): Observable<RestResponse> {
    return this.http.delete<RestResponse>(this.baseUrl + `/api/HotelInfo/DeleteHotelGroup?Id=${id}`, ApiHeaders.getOptions());
  }

  getHotelList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/HotelInfo/GetHotelList`, ApiHeaders.getOptions());
  }

  addHotel(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/HotelInfo/AddHotel`, formData);
  }

  getBrandCompanyWiseList(companyId: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/MasterBrand/GetMasterBrandAllByCompanyId?CompanyId=${companyId}`, ApiHeaders.getOptions());
  }


  // CRUD FOR LOCATION
  getLocationList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/MasterLocation/MasterLocationList`, ApiHeaders.getOptions());
  }
  addLocation(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/MasterLocation/AddMasterLocation`, formData);
  }
  updateLocation(formData: FormData): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/api/MasterLocation/UpdateMasterLocation`, formData);
  }
  deleteLocation(id: number): Observable<RestResponse> {
    return this.http.delete<RestResponse>(this.baseUrl + `/api/MasterLocation/DeleteMasterLocation?Id=${id}`, ApiHeaders.getOptions());
  }
  // CRUD FOR COMPANY
  getCompanyList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/MasterCompany/MasterCompanyList`, ApiHeaders.getOptions());
  }
  deleteCompany(id: number): Observable<RestResponse> {
    return this.http.delete<RestResponse>(this.baseUrl + `/api/MasterCompany/DeleteMasterCompany?Id=${id}`, ApiHeaders.getOptions());
  }
  addCompany(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/MasterCompany/AddMasterCompany`, formData);
  }
  updateCompany(formData: FormData): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/api/MasterCompany/UpdateMasterCompany`, formData);
  }
    // CRUD FOR DEPARTMENT

    getDesignationListById(departmentId: number): Observable<RestResponse> {
      return this.http.get<RestResponse>(this.baseUrl + `/api/MasterDesignation/DesignationListByDepartment?DepartmentId=${departmentId}`, ApiHeaders.getOptions());
    }

    getDepartmentList(): Observable<RestResponse> {
      return this.http.get<RestResponse>(this.baseUrl + `/api/MasterDepartment/MasterDepartmentList`, ApiHeaders.getOptions());
    }
    deleteDepartment(id: number): Observable<RestResponse> {
      return this.http.delete<RestResponse>(this.baseUrl + `/api/MasterDepartment/DeleteMasterDepartment?Id=${id}`, ApiHeaders.getOptions());
    }
    addDepartment(formData: FormData): Observable<RestResponse> {
      return this.http.post<RestResponse>(this.baseUrl + `/api/MasterDepartment/AddMasterDepartment`, formData);
    }
    updateDepartment(formData: FormData): Observable<RestResponse> {
      return this.http.put<RestResponse>(this.baseUrl + `/api/MasterDepartment/UpdateMasterDepartment`, formData);
    }
  
    // CRUD FOR DESIGNATION
    
    getDesignationList(): Observable<RestResponse> {
      return this.http.get<RestResponse>(this.baseUrl + `/api/MasterDesignation/MasterDesignationList`, ApiHeaders.getOptions());
    }
    deleteDesignation(id: number): Observable<RestResponse> {
      return this.http.delete<RestResponse>(this.baseUrl + `/api/MasterDesignation/DeleteMasterDesignation?Id=${id}`, ApiHeaders.getOptions());
    }
    addDesignation(formData: FormData): Observable<RestResponse> {
      return this.http.post<RestResponse>(this.baseUrl + `/api/MasterDesignation/AddMasterDesignation`, formData);
    }
    updateDesignation(formData: FormData): Observable<RestResponse> {
      return this.http.put<RestResponse>(this.baseUrl + `/api/MasterDesignation/UpdateMasterDesignation`, formData);
    }
  
  // CRUD FOR Brand
  getBrandList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/MasterBrand/GetMasterBrandAll`, ApiHeaders.getOptions());
  }
  deleteBrand(id: number): Observable<RestResponse> {
    return this.http.delete<RestResponse>(this.baseUrl + `/api/MasterBrand/DeleteMasterBrand?Id=${id}`, ApiHeaders.getOptions());
  }
  addBrand(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/MasterBrand/AddMasterBrand`, formData);
  }
  updateBrand(formData: FormData): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/api/MasterBrand/EditMasterBrand`, formData);
  }


  // CRUD FOR LEAVE
  getLeaveList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/MasterLeaveType/GetAllLeaveTypes`, ApiHeaders.getOptions());
  }
  deleteLeave(id: number): Observable<RestResponse> {
    return this.http.delete<RestResponse>(this.baseUrl + `/api/MasterLeaveType/DeleteLeaveType?id=${id}`, ApiHeaders.getOptions());
  }
  addLeave(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/api/MasterLeaveType/AddLeaveType`, formData);
  }
  updateLeave(formData: FormData): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/api/MasterLeaveType/UpdateLeaveType`, formData);
  }


  getMasterDocumentList(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/api/Employee/GetDocumentMasterList`, ApiHeaders.getOptions());
  }

  getCategoryList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/CategoryList`, formData);
  }

  deleteCategory(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/CategoryDelete`, formData);
  } 

  AddEditCategory(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AddEditCategory`, formData);
  } 

  

  getSubCategoryList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/SubCategoryList`, formData);
  }


  deleteSubCategory(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/SubCategoryDelete`, formData);
  }

  AddEditSubCategory(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AddEditSubCategory`, formData);
  } 


  getControlList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/SliderBannerList`, formData);
  }


  deleteControl(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/SliderBannerDelete`, formData);
  }

  AddEditSliderBanner(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AddEditSliderBanner`, formData);
  }

  AdminControl(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AdminControl`, formData);
  }

  UnitList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/UnitList`, formData);
  }

  AddEditProduct(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AddEditProduct`, formData);
  }

  ProductList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/ProductList`, formData);
  }

  ProductDelete(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/ProductDelete`, formData);
  }

  UserList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/UserList`, formData);
  }

  AddEditUser(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AddEditUser`, formData);
  }

  UserVerify(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/UserVerify`, formData);
  }

  EditProductsBulk(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/EditProductsBulk`, formData);
  }

  RouteList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/RouteList`, formData);
  }

  RouteMappingList(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/RouteMappingList`, formData);
  }

  AddEditRoute(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AddEditRoute`, formData);
  }

  RouteDelete(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/RouteDelete`, formData);
  }


}
